import { connect, MapStateToProps } from "react-redux";

import { UNKNOWN_KEY_TEXT } from "@multiweb/reactCore/i18n";
import { EMPTY_ARRAY } from "@multiweb/reactUtils";
import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { getInjectedComponentOnRender, ReplaceableComponentNames } from "../../customization/internalIndex";
import { getFocusedFormItemIndex } from "../../navigation";
import { getActiveSectionFormItemId, getFormChildIds, getFormItemTitle } from "../../selectors";
import { FormMenuComponentProps } from "../FormMenuComponent";

const mapStateToProps: MapStateToProps<FormMenuComponentProps, NoneOwnProps, IAppState> = (state) => {
    const formItemId = getActiveSectionFormItemId(state);
    return {
        title: formItemId ? getFormItemTitle(state, formItemId) : UNKNOWN_KEY_TEXT,
        formItemIds: formItemId ? getFormChildIds(state, formItemId) : EMPTY_ARRAY,
        focusedItemIndex: getFocusedFormItemIndex(state),
    };
};

export const FormMenu = connect(mapStateToProps)(getInjectedComponentOnRender(ReplaceableComponentNames.FormMenuComponent));
